import { Navigate, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import NoAccessPage from './pages/no_access';

import { maybeCurrentAccountState } from '../store';

import type { Account } from '@rewardopl/types';

type AuthFn = (user: Account | null) => boolean;

type AuthGateProps = {
  anyOf: AuthFn | AuthFn[];
  children: React.ReactElement;
};

export default function AuthGate({ anyOf, children }: AuthGateProps) {
  const location = useLocation();
  const currentAccount = useAtomValue(maybeCurrentAccountState);

  const isAuthorized = Array.isArray(anyOf)
    ? anyOf.some((fn) => fn(currentAccount))
    : anyOf(currentAccount);

  if (isAuthorized) {
    return children;
  }

  const { pathname, search } = location;

  const { returnPath = '/' } = (location.state || {}) as { returnPath?: string };

  const toPathname = (() => {
    if (currentAccount) {
      return returnPath;
    }

    if (pathname === '/') {
      return '/login';
    }

    return null;
  })();

  if (toPathname) {
    return <Navigate to={toPathname} replace />;
  }

  const state = { returnPath: pathname + search };

  return <NoAccessPage state={state} />;
}
